/**
 * Extracted from sections/ns-comparison-table-v3.liquid (inline <script> at line 386).
 * Config bridge: window.__nsComparisonTableV3Sections, keyed by section id. The Liquid the block
 * needed (its section id plus the settings listed in the bridge) is now
 * handed over as data, so the logic can live in a cacheable, deferred
 * asset instead of being parsed and compiled during the HTML parse
 * (INP work on the PDP). Boots once per registered section id.
 */

(function () {
  var cfg = window.__nsComparisonTableV3Sections = window.__nsComparisonTableV3Sections || {};
  function boot(nsSectionId, nsSettings) {
            (function () {
              let nsct3Swiper = null;
              let resizeTimer = null;

              function getRoot() {
                return document.getElementById(`shopify-section-${nsSectionId}`);
              }

              function syncRowHeights() {
                const root = getRoot();
                if (!root) return;

                const maxRow = nsSettings.maxRow;
                for (let i = 0; i <= maxRow; i++) {
                  const cells = root.querySelectorAll('[data-nsct3-row="' + i + '"]');
                  if (!cells.length) continue;

                  let max = 0;
                  cells.forEach(function (cell) {
                    cell.style.height = 'auto';
                    const h = cell.offsetHeight;
                    if (h > max) max = h;
                  });
                  cells.forEach(function (cell) {
                    cell.style.height = max + 'px';
                  });
                }

                // Header band sync. The columns are bottom-aligned, so unequal
                // header heights leave their TOP edges ragged. The featured band
                // sits `lift` px proud of the compare headers by design; every
                // other pixel of difference is a defect. This must run for
                // text-only compare headers too — scoping it to image-bearing
                // ones left a text-only header 63px short of the featured band.
                const featuredHead = root.querySelector('.nsct3__featured-head');
                const compHeads = [].slice.call(root.querySelectorAll('.nsct3__cell--comp-head'));
                if (featuredHead && compHeads.length) {
                  const lift = window.matchMedia('(min-width: 769px)').matches ? 12 : 8;
                  featuredHead.style.height = 'auto';
                  compHeads.forEach(function (cell) { cell.style.height = 'auto'; });
                  let tallestComp = 0;
                  compHeads.forEach(function (cell) {
                    if (cell.offsetHeight > tallestComp) tallestComp = cell.offsetHeight;
                  });
                  const band = Math.max(featuredHead.offsetHeight, tallestComp + lift);
                  featuredHead.style.height = band + 'px';
                  compHeads.forEach(function (cell) { cell.style.height = band - lift + 'px'; });
                }

                // The reviews/CTA footer sits inside the featured card, but the
                // table bottom-aligns its columns — so that extra height would
                // lift the card's rows out of line with their labels. Cancel it
                // with a negative bottom margin: the rows stay aligned and the
                // card hangs below the table, as the v4 brand shell did.
                // The negative margin also removes the footer from the flow, so
                // whatever follows the table (the mobile CTA, the footnote) would
                // ride up underneath the hanging card. Give the table an equal
                // positive margin to reserve exactly that space back.
                const featuredCol = root.querySelector('.nsct3__col--featured');
                const foot = root.querySelector('.nsct3__featured-foot');
                const table = root.querySelector('.nsct3__table');
                if (featuredCol && foot) {
                  featuredCol.style.marginBottom = '0px';
                  if (table) table.style.marginBottom = '0px';
                  const overhang = foot.offsetHeight;
                  featuredCol.style.marginBottom = -overhang + 'px';
                  if (table) table.style.marginBottom = overhang + 'px';
                }
              }

              function initNsct3Swiper() {
                const root = getRoot();
                if (!root) return;

                const swiperEl = root.querySelector('.nsct3__swiper');
                if (!swiperEl) return;
                if (typeof Swiper === 'undefined') return;

                if (nsct3Swiper) {
                  nsct3Swiper.destroy(true, true);
                  nsct3Swiper = null;
                }

                const prevEl = root.querySelector('.nsct3__prev');
                const nextEl = root.querySelector('.nsct3__next');
                const paginationEl = root.querySelector('.nsct3__pagination');
                const controlsEl = root.querySelector('.nsct3__controls');

                syncRowHeights();

                nsct3Swiper = new Swiper(swiperEl, {
                  slidesPerView: nsSettings.colsMobile,
                  slidesPerGroup: 1,
                  spaceBetween: 0,
                  speed: 600,
                  grabCursor: true,
                  loop: false,
                  watchOverflow: true,
                  navigation: prevEl && nextEl ? { nextEl: nextEl, prevEl: prevEl } : false,
                  pagination: paginationEl
                    ? {
                        el: paginationEl,
                        clickable: true,
                        type: 'bullets'
                      }
                    : false,
                  breakpoints: {
                    769: {
                      slidesPerView: nsSettings.colsDesktop,
                      slidesPerGroup: 1,
                      spaceBetween: 0
                    }
                  },
                  on: {
                    init: function () {
                      if (controlsEl) controlsEl.classList.toggle('is-locked', this.isLocked);
                      setTimeout(syncRowHeights, 0);
                    },
                    lock: function () {
                      if (controlsEl) controlsEl.classList.add('is-locked');
                    },
                    unlock: function () {
                      if (controlsEl) controlsEl.classList.remove('is-locked');
                    }
                  }
                });
              }

              function waitForSwiper(callback) {
                if (typeof Swiper !== 'undefined') {
                  callback();
                  return;
                }
                const checkInterval = setInterval(() => {
                  if (typeof Swiper !== 'undefined') {
                    clearInterval(checkInterval);
                    callback();
                  }
                }, 50);
              }

              waitForSwiper(initNsct3Swiper);

              window.addEventListener('load', syncRowHeights);

              window.addEventListener('resize', function () {
                clearTimeout(resizeTimer);
                resizeTimer = setTimeout(function () {
                  syncRowHeights();
                  if (nsct3Swiper) nsct3Swiper.update();
                }, 150);
              });

              if (typeof Shopify !== 'undefined' && Shopify.designMode) {
                document.addEventListener('shopify:section:load', function () {
                  waitForSwiper(initNsct3Swiper);
                });
              }
            })();
        
  }
  Object.keys(cfg).forEach(function (id) {
    var s = cfg[id];
    if (!s || s.__booted) return;
    s.__booted = true;
    boot(id, s);
  });
})();
